import Collection from "../../Collection";
import Sunmoon from ".";
export default class Sunmoons extends Collection {
  constructor(config) {
    super(config);
    this.models = config.data.map(datum => new Sunmoon({ data: datum }));
  }
}
